// Importing necessary modules and dependencies
import * as THREE from "three";
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";
import gsap from "gsap";
import { shuffle } from "../common/array-util";
import RAPIER from "@dimforge/rapier3d-compat";
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";

import effectVertexShader from "../shader/effect/vertex.glsl";
import effectFragmentShader from "../shader/effect/fragment.glsl";
import { getParticleSystem } from "./getParticleSystem";

gsap.registerPlugin(MotionPathPlugin);

export default class GameScene {
  // Constructor takes a scene and camera as parameters
  constructor(scene, renderer, world, camera) {
    this.renderer = renderer;
    this.scene = scene;
    this.world = world;
    this.camera = camera;

    this.onEvents = this.onEvents.bind(this);

    // Keep track of bodies and constraints we add so we can remove them cleanly
    this._bodiesAdded = [];
    this._constraintsAdded = [];
    this.selectedModels = [];
    this.matchEffects = [];
  }

  // Initialization method for setting up event listeners and initial state
  init(gui) {
    this.gui = gui;
    this.stackedIndex = 0;
    Global.gameStarted = false;
    this.raycaster = new THREE.Raycaster();
    this.mouse = new THREE.Vector2();

    this.canCheckForSleep = false;
    this.events = EventDispatcher.getObj();

    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
    this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
    this.events.addEventListener("GAME_EVENTS", this.onEvents);

    this.renderer.domElement.addEventListener(
      "click",
      this.onClick.bind(this),
      false,
    );
  }
  onClick(event) {
    if (!Global.gameStarted) return;

    if (event.type === "touchstart") {
      this.mouse.x = (event.touches[0].clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.touches[0].clientY / window.innerHeight) * 2 + 1;
    } else {
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    this.raycaster.ray.origin.copy(this.camera.position);
    this.raycaster.ray.direction
      .set(this.mouse.x, this.mouse.y, 1)
      .unproject(this.camera)
      .sub(this.camera.position)
      .normalize();
    this.raycaster.setFromCamera(this.mouse, this.camera);

    const hits = this.raycaster.intersectObjects(this.room.children, true);

    if (!hits.length) return;

    const _selected = hits[0].object.name.toLocaleLowerCase();
    const _selectedItem = hits[0].object;
    let _exists = false;
    let matchKey = null;
    Object.keys(Global.scenarioItems[Global.scenario]).forEach((key) => {
      const itemName = Object.keys(
        Global.scenarioItems[Global.scenario][key],
      )[0];
      console.log(itemName, "itemName", _selected);

      const match = _selected.includes(itemName.toLowerCase());
      const available = Global.scenarioItems[Global.scenario][key][itemName];

      console.log(itemName, match, available);

      if (
        _selected.includes(itemName.toLowerCase()) &&
        Global.scenarioItems[Global.scenario][key][itemName] === 0
      ) {
        matchKey = itemName;
        Global.scenarioItems[Global.scenario][key][itemName] = 1;
        _exists = true;

        console.log(itemName, "itemName", _selected);
        console.log(
          Global.scenarioItems[Global.scenario][key][itemName],
          "aaa",
          matchKey,
          "jjj",
          _exists,
        );
      }
    });

    if (_exists) {
      this.showAsSelected(_selectedItem, matchKey);
    }
    // if (Global.scenarioItems[scenario][this.stackedIndex]) {
    //   console.log(hits[0].object.name, 'hit object');
  }
  showAsSelected(selectedItem, selectedID) {
    this.collectIndex++;

    if (Global.soundEnabled) {
      document
        .querySelector(`#collect${(this.collectIndex % 2) + 1}Audio`)
        .play();
    }

    Global.collectedTotal++;
    document
      .querySelector(`#item_tray #${selectedID}`)
      .classList.add("active2");
    this.matchEffect = getParticleSystem({
      camera: this.camera,
      emitter: selectedItem,
      parent: this.room,
      rate: 1000.0,
      texture: "radGrad",
    });
    selectedItem.visible = false;
    Global.itemsCollected.push({
      scale: selectedItem.scale.clone(),
      item: selectedItem,
    });
    gsap.to(selectedItem.scale, {
      x: 0,
      y: 0,
      z: 0,
      ease: "back.in",
      onComplete: function (selectedItem) {}.bind(this, selectedItem),
      duration: 0.2,
    });
    //

    this.matchEffects.push(this.matchEffect);
    setTimeout(
      function (matchEffect, removeIndex) {
        matchEffect.dispose();
        // this.matchEffects.splice(removeIndex, 1);
      }.bind(this, this.matchEffect, this.matchEffects.length - 1),
      300,
    );

    const tick = new THREE.Mesh(
      new THREE.PlaneGeometry(0.3, 0.3),
      new THREE.MeshBasicMaterial({
        map: this.tickTex.clone(),
        side: THREE.DoubleSide,
        transparent: true,
        depthWrite: false,
        depthTest: false,
      }),
    );
    this.room.add(tick);
    tick.renderOrder = 999;
    tick.position.copy(selectedItem.position);
    // tick.position.y += 0.2;
    tick.lookAt(this.camera.position);
    tick.scale.set(0, 0, 0);
    gsap.to(tick.scale, {
      x: 1,
      y: 1,
      z: 1,
      ease: "bounce.out",
      delay: 0.2,
      duration: 0.3,
    });
    gsap.to(tick.scale, {
      x: 0,
      y: 0,
      z: 0,
      ease: "back.in",
      delay: 1,
      duration: 0.2,
      onComplete: function (tick) {
        this.room.remove(tick);
      }.bind(this, tick),
    });
    if (Global.collectedTotal >= Global.totalToCollect) {
      Global.taskCompleted = true;
      Global.gameStarted = false;
      this.events.dispatchEvent({
        type: "GAME_EVENTS",
        message: { event_type: "end_game" },
      });
    }
  }
  deepClone(object) {
    const clone = object.clone(true);

    clone.traverse((node) => {
      if (node.isMesh) {
        // Clone geometry
        node.geometry = node.geometry.clone();

        // Clone material (handle arrays too)
        if (Array.isArray(node.material)) {
          node.material = node.material.map((mat) => mat.clone());
        } else {
          node.material = node.material.clone();
        }
      }
    });

    return clone;
  }

  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "create_scene":
        this.createScene();
        break;
      case "update":
        this.update(data["message"]["data"]);
        break;
      case "start_time":
        this.startGame();
        break;
      case "time_up":
        this.stopGame();
        break;
      case "dispose":
        this.dispose();
        break;
    }
  }

  // If not already imported somewhere central:
  startGame() {
    this.collectIndex = 0;
    document.querySelectorAll(`#item_tray .item`).forEach((item) => {
      item.classList.remove("active");
      item.classList.remove("active2");
    });
    const keys = [
      ...new Set(
        Global.scenarioItems[Global.scenario].flatMap((obj) =>
          Object.keys(obj),
        ),
      ),
    ];
    keys.forEach((key) => {
      document.querySelector(`#item_tray #${key}`).classList.add("active");
    });
    Global.taskCompleted = false;
    Global.gameStarted = true;
  }
  stopGame() {
    Global.gameStarted = false;
  }
  createScene() {
    Global.scenarioItems = {
      conflict: [
        { flak_jacket: 0 },
        { firstaid: 0 },
        { foodpack: 0 },
        { torch: 0 },
        { walkie: 0 },
        { gas_mask: 0 },
        { mic: 0 },
        { tripod: 0 },
        { tent: 0 },
        { sleepy_bag: 0 },
      ],
      cyclone: [
        { life_jacket: 0 },
        { gum_boot: 0 },
        { umbrerlla: 0 },
        { raincoat: 0 },
        { foodpack: 0 },
        { walkie: 0 },
        { battery: 0 },
        { tent: 0 },
        { sleepy_bag: 0 },
        { generator: 0 },
      ],
      remote: [
        { tent: 0 },
        { sleepy_bag: 0 },
        { cookset: 0 },
        { stove: 0 },
        { firstaid: 0 },
        { mosquito: 0 },
        { mic: 0 },
        { walkie: 0 },
        { tripod: 0 },
        { foodpack: 0 },
      ],
    };
    Global.scenario = shuffle(Object.keys(Global.scenarioItems))[0];

    this.room = Global.assets["glbs"]["room"]["asset"].scene;
    this.room.position.set(0, -1.5, 0);
    this.room.rotation.set(0, -Math.PI * 0.65, 0);
    this.scene.add(this.room);
    this.room.traverse((child) => {
      if (child.isMesh) {
      }
    });
    this.tickTex = Global.assets["textures"]["tick"]["asset"];
  }

  update(data) {
    this.matchEffects.forEach((effect) => {
      effect.update(0.003 * Global.delta);
    });
    // if (this.matchEffects.) {
    //   console.log('update effect');
    //   this.matchEffect.update(0.003);
    // }
  }

  dispose() {
    if (this.room) {
      this.room.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.room);
      this.room = null;
    }
    if (this.flag) {
      this.flag.traverse((child) => {
        if (child.isMesh) {
          if (child.geometry) child.geometry.dispose();
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach((material) => material.dispose());
            } else {
              child.material.dispose();
            }
          }
        }
      });
      this.scene.remove(this.flag);
      this.scene.remove(this.flag2);
      this.scene.remove(this.flag3);
      this.scene.remove(this.flag4);
      this.flag = null;
      this.flag2 = null;
      this.flag3 = null;
      this.flag4 = null;
    }

    if (this.postBody) {
      this.postBody = null;
    }

    // Remove only bodies we added earlier
    if (this.scene.world) {
      // Remove bodies we added
      for (let b of this._bodiesAdded) {
        try {
          this.scene.world.removeBody(b);
        } catch (e) {
          // ignore remove errors
        }
      }
      this._bodiesAdded.length = 0;

      // Remove constraints we added (if any)
      for (let c of this._constraintsAdded) {
        try {
          this.scene.world.removeConstraint(c);
        } catch (e) {
          // ignore
        }
      }
      this._constraintsAdded.length = 0;
    }

    // Remove event listeners (guard events)
    if (this.events) {
      this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
      this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
      this.events.removeEventListener("GAME_EVENTS", this.onEvents);
    }

    if (window.gc) {
      window.gc();
    }
  }
}
